import React from 'react';
import { Typography } from '@mui/material'
import '../../../DialogTemplate/DialogTemplate.css';

export const RestrictedDialog = () => {
    return (
        <>
            <Typography className='dialog_title_bold'>
                There are some things SmartCard holders cannot buy with their SmartCard
            </Typography>
            
            <Typography className='dialog_text'>
                {'\nThere are some things SmartCard holders cannot buy with their SmartCard. They can’t:'}
                </Typography>
            <div className='dialog_text_container'>
                <div className='dialog_flex'>
                    <Typography className='dialog_text_point'>{"•\t"}</Typography>
                    <Typography className='dialog_text'>{"buy tobacco or tobacco products"}</Typography>
                </div>
                <div className='dialog_flex'>
                    <Typography className='dialog_text_point'>{"•\t"}</Typography>
                    <Typography className='dialog_text'>{"buy pornography"}</Typography>
                </div>
                <div className='dialog_flex'>
                    <Typography className='dialog_text_point'>{"•\t"}</Typography>
                    <Typography className='dialog_text'>{"buy alcohol or homebrew kits/concentrates"}</Typography>
                </div>
                <div className='dialog_flex'>
                    <Typography className='dialog_text_point'>{"•\t"}</Typography>
                    <Typography className='dialog_text'>{"gamble"}</Typography>
                </div>
                <div className='dialog_flex'>
                    <Typography className='dialog_text_point'>{"•\t"}</Typography>
                    <Typography className='dialog_text'>{"buy cash-like products* and some gift cards"}</Typography>
                </div>
                <div className='dialog_flex'>
                    <Typography className='dialog_text_point'>{"•\t"}</Typography>
                    <Typography className='dialog_text'>{"get cash out."}</Typography>
                </div>
                <Typography className='dialog_text'>
                {'\n* A cash-like product is an item that can be used like cash to purchase tobacco or tobacco products, pornography or alcohol, to gamble or to withdraw cash. Examples include some gift cards, prepaid cards, store credit or e-vouchers.'}
                </Typography>
            </div>
        </>
    )
}